export const getUserDisplayName = (user = {}) => {
  if (!user) return '';

  if (user.firstName || user.lastName) {
    return `${user.firstName || ''} ${user.lastName || ''}`.trim();
  }

  return user.username || user.name || user.fullName || '';
};

export const getUserSecondaryLabel = (user = {}) => {
  if (!user) return '';

  const parts = [];

  if (user.designation?.trim()) {
    parts.push(user.designation.trim());
  }

  if (user.department?.departmentName) {
    parts.push(user.department.departmentName);
  } else if (user.department?.departmentCode) {
    parts.push(user.department.departmentCode);
  }

  return parts.join(' · ');
};

export const shouldShowUserSecondaryLabel = (user) => {
  return Boolean(getUserSecondaryLabel(user));
};

export const formatUserOptionLabel = (user) => {
  const name = getUserDisplayName(user);
  const secondary = getUserSecondaryLabel(user);

  if (!secondary) {
    return name;
  }

  return `${name} (${secondary})`;
};
